import Alimony from './Alimony';

export default Alimony;
